import Card, { type CardProps } from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import type { CardHeaderProps as MuiCardHeaderProps } from '@mui/material/CardHeader';

import { Title } from '@ifs-gcp/components';

import styles from './page-card.module.scss';

type CardHeaderProps = MuiCardHeaderProps & {
  title?: string;
};

type PageCardProps = CardProps & {
  cardHeaderProps?: CardHeaderProps;
  noContentPadding?: boolean;
};

export const PageCard = ({
  children,
  noContentPadding,
  cardHeaderProps = {},
  ...cardProps
}: PageCardProps) => {
  const { title, ...restCardHeaderProps } = cardHeaderProps;

  return (
    <Card {...cardProps} className={styles.pageCard}>
      {Boolean(Object.keys(cardHeaderProps)?.length) && (
        <CardHeader
          {...restCardHeaderProps}
          {...(title && {
            title: <Title>{title}</Title>,
          })}
          className={styles.pageHeader}
        />
      )}
      <CardContent className={`${styles.cardContent} ${noContentPadding ? styles.noPadding : ''}`}>
        {children}
      </CardContent>
    </Card>
  );
};
